import { polyfill } from './numberFormatPolyfill';

export const formatCurrency = async ({
  currency,
  price,
  locale
}: {
  price: number;
  currency: string;
  locale: string;
}) => {
  // Use intl-numberformat polyfill to fix crashes for browsers that do not support ESNext
  await polyfill(locale);

  /**
   * Intl.NumberFormat will give us the correct ISO format back for the country that you are in
   * which for de-DE would be x.xxx,xx €
   */
  try {
    const formatParts: Intl.NumberFormatPart[] = new Intl.NumberFormat(locale, {
      currency,
      style: 'currency'
    }).formatToParts(price);

    return formatParts.reduce((concatenatedPrice: string, formattedPart: Intl.NumberFormatPart) => {
      return `${concatenatedPrice}${formattedPart.value}`;
    }, ``);
  } catch (error) {
    const errorMsg = (error as Error)?.message;
    if (errorMsg?.includes('Incorrect locale information provided')) {
      console.error(`local ${locale} not found`);
      return;
    }
    console.error(error);
  }
};
